import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';
export default function BulkTaskAssignToType(state = initialState.bulkTaskAssignToType, action) {
	switch (action.type) {
		case types.BULK_TASK_CHANGE_ASSIGN_TO_TYPE: {
			return action.data;
		}
		case types.BULK_TASK_DEFAULT_ASSIGN_TO_TYPE: {
			return initialState.bulkTaskAssignToType;
		}
		default:
			return state;
	}
}
